<template>
  <div class="rightContentCom ashComWrap">
    <div class="comTitle">
      <DateQuick
        @getDateData="getDateData"
        :type="dateType"
        :selectAsset="selectAsset"
      />
    </div>
    <div class="comContentBox content">
      <template v-if="menuData?.treeValue == 'Imbalance'">
        <Unbalance :parameterItem="parameterItem" />
      </template>
      <template v-else>
        <div
          class="listBox"
          v-if="$route.path == '/demandAnalysis'"
          style="margin: 10px 0"
        >
          <el-radio-group v-model="checkList" @change="changeRadio">
            <el-radio
              v-for="v in checkboxList"
              :label="v.value"
              :key="v.value"
              >{{ v.name }}</el-radio
            >
          </el-radio-group>
        </div>
        <div
          class="tabCharts"
          :style="{ height: $route.path == '/demandAnalysis' ? '90%' : '100%' }"
        >
          <div class="tabs">
            <el-radio-group v-model="radio" size="mini">
              <el-radio-button label="图表"></el-radio-button>
              <el-radio-button label="数据"></el-radio-button>
            </el-radio-group>
          </div>
          <div class="chartsBox">
            <PublicEcharts
              v-if="radio == '图表'"
              :id="'distri'"
              :chartsData="chartsData"
              :type="'lightLine'"
            />
            <OriginalTable
              v-if="radio == '数据'"
              :tableHead="tableHead"
              :tableList="tableList"
            />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import DateQuick from "@/components/DatePicker/DateQuick.vue";
import PublicEcharts from "@/components/PublicEcharts.vue";
import OriginalTable from "@/components/table/OriginalTable.vue";
import Unbalance from "./Unbalance.vue";
import { handleNumDecimal } from "@/assets/js/utils";
export default {
  props: {
    menuData: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    DateQuick,
    PublicEcharts,
    OriginalTable,
    Unbalance,
  },
  data() {
    return {
      dateType: "date",
      checkboxList: [
        { name: "平均值", value: "avg" },
        { name: "最高值", value: "max" },
        { name: "最低值", value: "min" },
      ],
      checkList: "avg",
      radio: "图表",
      chartsData: { title: "", unit: "", xData: [], dataArr: [] },
      tableHead: [{ label: "时间", prop: "time" }],
      tableList: [],
      selectAsset: {},
      parameterObj: {},
      parameterItem: {},
    };
  },
  watch: {
    menuData: {
      handler() {
        this.selectAsset = this.menuData ?? {};
      },
      deep: true,
    },
  },
  methods: {
    getDateData(data) {
      if (this.selectAsset.treeValue !== "Imbalance") {
        this.$store.commit("SET_LOADING", true);
      }
      this.parameterItem = Object.assign({}, this.selectAsset, data);
      this.parameterObj = data;
      this.chartsData.unit = "";
      this.chartsData.xData = [];
      this.chartsData.dataArr = [];
      this.tableHead = [{ label: "时间", prop: "time" }];
      this.tableList = [];
      if (this.$route.path == "/distributingRun") {
        //运行状态
        this.getRunStateCharts(data);
      } else if (this.$route.path == "/demandAnalysis") {
        //需量分析
        this.getDemandAnalysis();
      } else if (
        this.$route.path == "/powerQuality" &&
        this.selectAsset.treeValue === "Harmonic"
      ) {
        this.getHarmonicCharts();
      }
    },
    // 电能质量
    async getHarmonicCharts() {
      let res = await api.PDSGetHarmonicCharts({
        assetId: this.selectAsset.id,
        key: this.parameterObj.key,
        date: this.parameterObj.timeValue,
        dateType: "DAY",
      });
      if (res && res.data.code == 200) {
        this.$store.commit("SET_LOADING", false);
        if (res.data.data.length) {
          this.handlerDataFun(res.data.data, "HH:mm");
        }
      }
    },
    // 运行状态图表
    async getRunStateCharts(data) {
      let res = await api.PDSGetRunStateCharts({
        deviceId: data.activeDevices,
        key: data.activeParameter.key,
        name: data.activeParameter.name,
        date: data.timeValue,
        dateType: "DAY",
      });
      if (res && res.data.code == 200) {
        this.$store.commit("SET_LOADING", false);
        if (res.data.data.length) {
          this.handlerDataFun(res.data.data, "HH:mm");
        }
      }
    },

    changeRadio() {
      if (!this.parameterObj.activeParameter?.name) {
        this.$message.warning("请选择参数");
        return;
      }
      if (!this.parameterObj.activeDevices) {
        this.$message.warning("请选择设备");
        return;
      }
      this.$store.commit("SET_LOADING", true);
      this.chartsData.unit = "";
      this.chartsData.xData = [];
      this.chartsData.dataArr = [];
      this.tableHead = [{ label: "时间", prop: "time" }];
      this.tableList = [];
      this.getDemandAnalysis();
    },
    // 需量分析图表
    async getDemandAnalysis() {
      let res = await api.PDSGetDemandAnalysis({
        deviceId: this.parameterObj.activeDevices,
        key: this.parameterObj.activeParameter.key,
        name: this.parameterObj.activeParameter.name,
        date: this.parameterObj.timeValue,
        dateType: "MONTH",
        aggregateType: this.checkList,
      });
      if (res && res.data.code == 200) {
        this.$store.commit("SET_LOADING", false);
        if (res.data.data.length) {
          this.handlerDataFun(res.data.data, "DD日");
        }
      }
    },
    handlerDataFun(arr, time) {
      this.chartsData.unit = arr[0]?.unit ?? "";
      arr[0].tsKVList.map((v) => {
        this.tableHead.push({
          label: this.chartsData.unit
            ? `${v.name}/${this.chartsData.unit}`
            : v.name,
          prop: v.name,
        });
      });
      let newArr = [];
      arr.map((v) => {
        this.chartsData.xData.push(this.$moment(v.ts).format(time));
        this.tableList.push({ time: this.$moment(v.ts).format(time) });
        newArr.push(v.tsKVList);
      });
      for (let i = 0; i < newArr[0].length; i++) {
        this.chartsData.dataArr.push({ name: "", data: [] });
        newArr.forEach((item, index) => {
          this.chartsData.dataArr[i].name = item[i].name;
          this.chartsData.dataArr[i].data.push(
            item[i].value ? handleNumDecimal(item[i].value) : ""
          );
          if (i === 0) {
            item.map((v) => {
              this.tableList[index][v.name] = v.value
                ? handleNumDecimal(v.value)
                : "";
            });
          }
        });
      }
    },
  },
  created() {
    this.dateType = this.$route.path == "/demandAnalysis" ? "month" : "date";
  },
};
</script>

<style lang="scss" scoped>
.rightContentCom {
  .content {
    width: 96%;
    margin: 0 auto;

    .tabCharts {
      width: 100%;

      .tabs {
        width: 100%;
        height: 6%;
        @include setFlexStart;
      }
      .chartsBox {
        width: 100%;
        height: 94%;
      }
    }
  }
}
</style>
